<div
  id="uzd-two-three-uz"
  [ngStyle]="{'font-size.px': options.fontSize}"
  class="blank-layout">

  <h4 class="title">
    {{ options.title }}
  </h4>

  <form [formGroup]="form">
    <div class="clr-row">
      <div class="clr-col-sm-12">
        <input [ngStyle]="{ 'font-size.px': options.fontSize }" clrInput formControlName="uz_date" />
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">П.І.Б:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_pib" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кількість плодів:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_plodiv_count">
            <option value="один">один</option>
            <option value="два">два</option>
            <option value="три">три</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Вага:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_vaga" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Положення плода:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_poloz_ploda">
            <option value="поздовжнє">поздовжнє</option>
            <option value="поперечне">поперечне</option>
            <option value="косе">косе</option>
            <option value="нестійке">нестійке</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Передлежання:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_predlezannya">
            <option value="головне">головне</option>
            <option value="сідничне">сідничне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Серцебиття:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_sertce">
            <option value="ритмічне">ритмічне</option>
            <option value="аритмічне">аритмічне</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">ЧСС:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_chss" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Рухи плода:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_ruh_ploda" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Біпарієтральний розмір (БПР):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_bpr" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Структура мозку:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_brain_str">
            <option value="б/о">б/о</option>
            <option value="огляд затруднено">огляд затруднено</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Окружність голови (ОГ):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_og" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Носогубний трикутник:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_noso_triangle">
            <option value="б/о">б/о</option>
            <option value="огляд затруднено">огляд затруднено</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Лобно-потиличний розмір (ЛПР):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_lpr" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Бокові шлуночки (БШ):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_bsh" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Потиличні роги:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_pot_rog" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">4-х камерний розтин серця:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_chkam" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Легенева артерія:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_leg_art" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ао:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_ao" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Зріз на трьох судинах:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_zriz_tr" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Легені (ступінь зрілості):</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_leg_st">
            <option value="зрілі">зрілі</option>
            <option value="І ст.">І ст.</option>
            <option value="ІІ ст.">ІІ ст.</option>
            <option value="ІІІ ст.">ІІІ ст.</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Мозочок:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_mozochok" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кісточка перенісся:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_kistochka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Довжина стегна (ДС):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_dc" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Середній діаметр грудної клітини (СДГК):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_sdgk" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Окружність живота (ОЖ):</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_ozh" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">К-сть навколоплідних вод:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_kilkist_vod">
            <option value="нормальна">нормальна</option>
            <option value="збільшена">збільшена</option>
            <option value="зменшена">зменшена</option>
            <option value="мілкодисперсні">мілкодисперсні</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Амніотичний індекс:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_index" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' передня ', 'uz_platsenty')"> передня </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' задня ', 'uz_platsenty')"> задня </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' права бокова ст. ', 'uz_platsenty')"> права бокова ст. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' ліва бокова ст. ', 'uz_platsenty')"> ліва бокова ст. </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' дно матки ', 'uz_platsenty')"> дно матки </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Локалізація плаценти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_platsenty"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' 0 ', 'uz_stupin_zrilosti')"> 0 </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' I ', 'uz_stupin_zrilosti')"> I </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' II ', 'uz_stupin_zrilosti')"> II </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' III ', 'uz_stupin_zrilosti')"> III </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Ступінь зрілості:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_stupin_zrilosti"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' високо ', 'uz_nizniy_kray')">  високо  </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' на мм від ', 'uz_nizniy_kray')">  на мм від  </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Нижній край плаценти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_nizniy_kray"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Товщина плаценти:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_tovshuna" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' лакуни ', 'uz_patolog_platsenty')"> лакуни </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' петрифікати ', 'uz_patolog_platsenty')"> петрифікати </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' кальцинати ', 'uz_patolog_platsenty')"> кальцинати </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Патологічні включення плаценти:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_patolog_platsenty"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' так ', 'uz_zrizu_petel')"> так </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' ні ', 'uz_zrizu_petel')"> ні </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Зрізи петель пуповини в шийномум трикутнику:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_zrizu_petel"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-select-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Пуповина: кількість судин:</label>
          <select [ngStyle]="{ 'font-size.px': options.fontSize }" clrSelect name="options" formControlName="uz_pupovyna">
            <option value="дві">дві</option>
            <option value="три">три</option>
          </select>
        </clr-select-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Пупочне кільке:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_pupo_kilce" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Шийка матки:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_shuyka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Опис рубця:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_shuyka" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">вн/вічко:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_vnvichko" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Цервікальний канал:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_tservik" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Термін по гестації:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_terminpogest" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Термін пологів:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_termin" />
        </clr-input-container>
      </div>
    </div>

    <div class="text-center-container text-center bold-text">
      <strong>ДОПЛЕРОМЕТРІЯ</strong>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">S/D:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_sd" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Кровоплин судин:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_krovoplun" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">CMA:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_cma" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">IR:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_ir" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <clr-input-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Pi:</label>
          <input autocomplete="off" [ngStyle]="{ 'font-size.px': options.fontSize }" placeholder="" clrInput name="name" formControlName="uz_pi" />
        </clr-input-container>
      </div>
    </div>

    <div class="clr-row button-row">
      <div class="clr-col-sm-12 button-left">
        <button class="btn btn-primary" (click)="copyDataToTextArea(' Величина плода відповідає ', 'uz_result')"> Величина плода відповідає </button>
        <button class="btn btn-primary" (click)="copyDataToTextArea(' тижням вагітності ', 'uz_result')"> тижням вагітності </button>
      </div>
      <div class="clr-col-sm-12 full-width-input">
        <clr-textarea-container>
          <label [ngStyle]="{ 'font-size.px': options.fontSize }">Висновок УЗД:</label>
          <textarea [ngStyle]="{ 'font-size.px': options.fontSize }" clrTextarea name="description" formControlName="uz_result"></textarea>
        </clr-textarea-container>
      </div>
    </div>

    <div class="clr-row">
      <div class="clr-col-sm-12 full-width-input">
        <app-doctors [parentForm]="form" [fontSize]="options.fontSize"></app-doctors>
      </div>
    </div>

    <div class="clr-row">
      <div class="print-block"></div>
    </div>

  </form>
</div>

<app-blank-actions
  [font]="options.fontSize"
  (print)="printCurrentPage()"
  (fontSize)="updateFontSize($event)">
</app-blank-actions>
